/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';

import { State } from '../reducers';

import { UserRole } from './entities';

const locationHelper = locationHelperBuilder({});

export const visibleOnlyAdmin1 = (roles: UserRole[]) =>
  connectedAuthWrapper({
    authenticatedSelector: (state: State) =>
      state.user && state.user.profile && state.user.profile.role.exists((role: UserRole) => roles.includes(role)),
    wrapperDisplayName: 'VisibleOnlyAdmin',
  });

export const userIsAuthenticated = connectedRouterRedirect<any, State>({
  // The url to redirect user to if they fail
  redirectPath: '/login',
  // Determine if the user is authenticated or not
  authenticatedSelector: (state: State) => {
    // console.log('state', state);
    return state.user.isLoggedIn;
  },
  // A nice display name for this check
  wrapperDisplayName: 'UserIsAuthenticated',
});

export const userIsNotAuthenticated = connectedRouterRedirect<any, State>({
  // This sends the user either to the query param route if we have one, or to the landing page if none is specified and the user is already logged in
  redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/',
  // This prevents us from adding the query parameter when we send the user away from the login page
  allowRedirectBack: false,
  // This prevents us from adding the query parameter when we send the user away from the login page
  // Determine if the user is authenticated or not
  authenticatedSelector: (state) => !state.user.isLoggedIn,
  // A nice display name for this check
  wrapperDisplayName: 'UserIsNotAuthenticated',
});

export const visibleOnlyTo = (roles: UserRole[] | UserRole, Component: any) => {
  const checkRoles = Array.isArray(roles) ? roles : [roles];
  return connectedAuthWrapper<any, State>({
    authenticatedSelector: (state) => state.user && state.user.profile && state.user.profile.role.exists((r) => checkRoles.includes(r)),
    wrapperDisplayName: 'VisibleOnlyToRoles',
  })(Component);
};
